import { LoadingOutlined } from "@ant-design/icons";
import styles from "./MiniLoader.module.scss";
import cn from "classnames";
import { IMiniLoaderProps } from "./MiniLoader.props";

export default function MiniLoader({ className }: IMiniLoaderProps) {
  return (
    <div className={cn(styles.wrapper, className)}>
      <LoadingOutlined rev={undefined} />
    </div>
  );
}
